import ActionTypes from "../../../../constants/ActionTypes";
import { ISendOrderEmailStatusState, ISetSendOrderToEmailStatusAction } from "./types";

const initialState: ISendOrderEmailStatusState = {
  status: null,
};

const orderSendToEmailStatusReducer = (
  state = initialState,
  action: ISetSendOrderToEmailStatusAction,
): any => {
  switch (action.type) {
  case ActionTypes.ORDER.MANHATTAN.SET_SEND_ORDER_TO_EMAIL_STATUS:
    return {
      ...state,
      status: action.payload
    };
  }
  return state;
};

export default orderSendToEmailStatusReducer;
